import * as React from "react";
import { compose, pure, setDisplayName } from "recompose";
var APP_STORE_URL = "https://apps.apple.com/fr/app/eqwin/id6443553957";
var PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.eqwin.app";
export var Render = function () {
    return React.createElement("div", { style: {
            display: "flex",
            gap: 12,
            justifyContent: "center",
            marginTop: 24
        } },
        React.createElement("a", { href: APP_STORE_URL, target: "_blank", rel: "noopener noreferrer", style: {
                display: "flex",
                alignItems: "center",
                gap: 8,
                backgroundColor: "#1B0406",
                color: "#fff",
                borderRadius: 10,
                padding: "8px 16px",
                textDecoration: "none",
                fontFamily: "Area Normal, sans-serif",
                fontSize: 12,
                fontWeight: 700
            } },
            React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 56.693 56.693", fill: "#fff" },
                React.createElement("path", { d: "M41.777,30.517c-0.062-6.232,5.082-9.221,5.312-9.372c-2.891-4.227-7.395-4.807-8.998-4.873c-3.83-0.389-7.477,2.256-9.42,2.256c-1.939,0-4.941-2.199-8.117-2.143c-4.178,0.062-8.029,2.43-10.179,6.17c-4.339,7.527-1.11,18.682,3.118,24.791c2.067,2.986,4.532,6.346,7.766,6.223c3.117-0.123,4.293-2.016,8.061-2.016s4.826,2.016,8.123,1.953c3.352-0.061,5.477-3.043,7.527-6.041c2.373-3.469,3.35-6.828,3.408-6.998C48.305,40.433,41.844,37.958,41.777,30.517z" }),
                React.createElement("path", { d: "M35.582,12.229c1.715-2.082,2.877-4.975,2.561-7.855c-2.475,0.1-5.471,1.645-7.248,3.725c-1.592,1.846-2.984,4.785-2.611,7.613C31.045,15.926,33.861,14.307,35.582,12.229z" })),
            React.createElement("div", null,
                React.createElement("div", { style: { fontSize: 8, fontWeight: 400, lineHeight: 1 } }, "Download on the"),
                React.createElement("div", { style: { fontSize: 14, lineHeight: 1.3 } }, "App Store"))),
        React.createElement("a", { href: PLAY_STORE_URL, target: "_blank", rel: "noopener noreferrer", style: {
                display: "flex",
                alignItems: "center",
                gap: 8,
                backgroundColor: "#1B0406",
                color: "#fff",
                borderRadius: 10,
                padding: "8px 16px",
                textDecoration: "none",
                fontFamily: "Area Normal, sans-serif",
                fontSize: 12,
                fontWeight: 700
            } },
            React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 512 512", fill: "none" },
                React.createElement("path", { d: "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z", fill: "#fff" })),
            React.createElement("div", null,
                React.createElement("div", { style: { fontSize: 8, fontWeight: 400, lineHeight: 1 } }, "Get it on"),
                React.createElement("div", { style: { fontSize: 14, lineHeight: 1.3 } }, "Google Play"))));
};
export function enhance() {
    return compose(pure, setDisplayName("AppStoreLinks"));
}
export var AppStoreLinks = enhance()(Render);
